import { Loading } from '@winnin/winnin_ui.components.loading'

import type { ICreatorClustersWrapperViewProps } from './creator-clusters-wrapper.types'

export const CreatorClustersWrapperView = ({
  children,
  ClusterPage,
  isLoading,
  showClusterPage,
}: ICreatorClustersWrapperViewProps) => {
  if (isLoading) {
    return <Loading />
  }

  if (showClusterPage) {
    return <ClusterPage />
  }

  return <>{children}</>
}
